// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3kmYh","gfeWrapper":"CalendarEvent_gfeWrapper__1N79M"};